<template>
  <div class="footer__container">
    <v-container mt-8>
      <TheFooterSocials/>

      <TheFooterPartners/>

      <div class="separator"></div>

      <v-row>
        <TheFooterContact/>

        <TheFooterMenu/>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import TheFooterSocials from './TheFooterSocials.vue'
  import TheFooterPartners from './TheFooterPartners.vue'

  import TheFooterContact from './TheFooterContact.vue'
  import TheFooterMenu from './TheFooterMenu.vue'

  export default {
    name: 'TheFooter',

    components: {
      TheFooterSocials,
      TheFooterPartners,
      TheFooterContact,
      TheFooterMenu,
    },
  }
</script>

<style lang="sass" scoped>
  @import "@/assets/styles/_config.sass"

  .separator
    border-bottom: solid 2px #fff

  .footer
    &__container
      line-height: 2
      font-size: 16px
      height: 400px
      background-color: $secondary-color
      color: #fff
      height: 100%

      & .container
        max-width: 1080px !important


  ::v-deep .footer

    &__contact-title
      letter-spacing: 0.75px
      color: #fff
      padding: 0 0 10px
      font-size: 16px
      font-weight: 700

    &__logo
      width: 80px
      max-width: 115px

    &__title
      font-size: 30px
      text-align: center
      font-weight: bold

  ::v-deep .v-btn--outlined
    border: 2px solid
    padding: 20px 24px !important
    text-transform: none
    font-size: 18px

  @media (max-width: 960px)
    .footer__logo-container
      text-align: center
      margin-top: 35px

    ::v-deep .footer__title
      font-size: 15px
      margin: 10px 0px
</style>
